import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";

import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBrief } from "@shared/lib/types/brief";
import { BRIEF_LIST_QUERY_KEY } from "../constants";
import { setBriefByIdQueryData } from "./useGetBriefById";

export function useSyncBriefGoogleSheets(briefId: string) {
  const {
    mutate: syncGoogleSheet,
    isLoading: isSyncing,
    isSuccess: isSynced,
    variables,
    data,
  } = useMutation({
    mutationFn: (payload: {
      type: "pricing" | "accountManager" | "addCreators" | "editCreators";
    }) =>
      BriefService.syncGoogleSheet(briefId, payload.type).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, response, params) => {
      if (response) {
        setBriefByIdQueryData(c, briefId, response as BackednResponse<IBrief>);
      }
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
      if (params.type === "addCreators" || params.type === "editCreators") {
        return;
      }
      ToastService.success(
        `${
          params.type === "pricing" ? "Pricing" : "Account Manager"
        } Google Sheet synced successfully`
      );
    },
  });

  return {
    syncGoogleSheet,
    isSyncing,
    isSynced,
    variables,
    syncedBrief: data as BackednResponse<IBrief> | undefined,
  };
}
